import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable';
import { Product } from '../entities/product.entities'
import { ProductService } from '../services/product.service'
import { Item } from '../entities/item.entities'
@Injectable()

export class CartService {

    public items: Item[];
    cheCkclick: boolean = false;
    public cont: number = 0;
    public totalPrice: number = 0;
    constructor(private productService: ProductService) {
        
        //localStorage.clear();
        this.loadCart();
        this.cont = this.loadCount();
        this.totalPrice = this.loadTotalMonney()
        
    }
    getCart(): Item[] {
        return this.items
    }
    pushCart(id: string) {
        this.cheCkclick = true;
        if (id) {
            var item: Item = {
                product: this.productService.findProductID(id),
                quantity: 1
            }
            if (localStorage.getItem('cart') == null) {
                let cart: any[] = [];
                cart.push(JSON.stringify(item));
                localStorage.setItem('cart', JSON.stringify(cart))
                
            } else {
                let cart: any = JSON.parse(localStorage.getItem('cart'));
                let index: number = -1;
                for (var i = 0; i < cart.length; i++) {
                    let item: Item = JSON.parse(cart[i]);
                    //console.log(item)
                    if (item.product.id === id) {
                        //console.log(item)
                        index = i;
                        break;
                    }
                }
                if (index == -1) {
                    cart.push(JSON.stringify(item));
                    localStorage.setItem('cart', JSON.stringify(cart))
                    
                } else {
                    let item: Item = JSON.parse(cart[index]);
                    item.quantity += 1;
                    cart[index] = JSON.stringify(item);
                    localStorage.setItem("cart", JSON.stringify(cart))
                    
                }
            }
            this.loadCart();
            this.cont = this.loadCount();
            this.totalPrice = this.loadTotalMonney()
        } else {
            this.loadCart();
            this.cont = this.loadCount();
            this.totalPrice = this.loadTotalMonney()
        }
    }
    decrementCart(id: string) {
        let cart: any = JSON.parse(localStorage.getItem('cart'));
        for (var i = 0; i < cart.length; i++) {
            if (this.items[i].product.id == id) {
                let item: Item = JSON.parse(cart[i]);
                item.quantity -= 1;
                cart[i] = JSON.stringify(item);
                localStorage.setItem("cart", JSON.stringify(cart))
                this.loadCart()
                this.cont = this.loadCount();
                this.totalPrice = this.loadTotalMonney()
                break;
            }
        }
    }

    loadCart(): void {
        this.items = [];
        let cart = JSON.parse(localStorage.getItem('cart'));
        if (cart != null) {
            for (var i = 0; i < cart.length; i++) {
                let item = JSON.parse(cart[i]);
                this.items.push({
                    product: item.product,
                    quantity: item.quantity
                })
            }
        }
        this.cont = this.loadCount();
       
    }
    loadCount() {
        let countItem: number = 0;
        for (var i = 0; i < this.items.length; i++) {
            countItem += this.items[i].quantity
        }
        return countItem;
    }

    private loadTotalMonney() {
        let TotalMonney: number = 0;
        let tmpTotal: number = 0;
        for (var i = 0; i < this.items.length; i++) {
            tmpTotal = this.items[i].product.price * this.items[i].quantity
            TotalMonney += tmpTotal
        }
        return TotalMonney;
    }
    deleteItem(i) {
        
        let cart: any = JSON.parse(localStorage.getItem('cart'));
        let item: Item = JSON.parse(cart[i]);
        item.quantity = 0;
        cart[i] = JSON.stringify(item);
        localStorage.setItem("cart", JSON.stringify(cart))
        this.loadCart()
        this.cont = this.loadCount();
        this.totalPrice = this.loadTotalMonney()
    }
    public loadquantity(id: string) {
        let index: number = -1
        for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].product.id == id) {
                index = i
            }
            if (i < this.items.length) {
                break;
            }
        }
        return this.items[index].quantity
    }

}


// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/services/cart.service.ts